export default __webpack_public_path__ + "static/media/video-icon.9e60494f.svg";